export enum EnumTheme {
  Light = 1,
  Dark = 2,
}

export enum EnumUser {
  Clinic = "Clinic",
  Provider = "Provider",
  Patient = "Patient",
}

export enum EnumFeedback {
  Success = "success",
  Error = "error",
  Info = "info",
}

export enum EnumAuthMethod {
  Email = "email",
  Phone = "phone",
}

export enum EnumResponse {
  Success = 200,
  Error = 500,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  None = 0,
}

export enum EnumGoogleResponse {
  InvalidGrant = "invalid_grant",
  Unauthorized = "UNAUTHENTICATED",
}

export enum EnumService {
  UrgentCare = 1,
  Pharmacy = 2,
  RapidReferrals = 3,
  ChronicDiseases = 4,
  TravelClinic = 5,
  SexualHealth = 6,
  WomensHealth = 7,
  WalkInClinic = 9,
  PhysicalHealth = 10,
  MentalHealth = 11,
  Health360 = 12,
}

export enum EnumPharmacy {
  MinorAilments = "minor_ailments",
}

export enum EnumRapidReferrals {
  Physiotherapy = "physiotherapy",
  Orthotics = "orthotics",
  MassageTherapy = "massage_therapy",
  CompressionStockings = "compression_stockings",
}

export enum EnumChronicDiseases {
  Diabetes = "diabetes",
  Hypertension = "hypertension",
  BackPain = "back_pain",
  ChronicPain = "chronic_pain",
}

export enum EnumMentalHealth {
  Depression = "depression",
  Anxiety = "anxiety",
  SubstanceAddiction = "substance_addiction",
  StressManagement = "stress_management",
}

export enum EnumTravelClinic {
  FirstConsultation = "first_consultation",
  Injections = "injections",
}

export enum EnumSexualHealth {
  SexuallyTransmittedInfections = "sti",
  NoSymptoms = "no_symptoms",
  ActiveSymptoms = "active_symptoms",
}

export enum EnumWomensHealth {
  PAPSmears = "pap_smears",
  BirthControl = "birth_control",
}

export enum EnumAppointmentStatus {
  None = -1,
  WalkIn = 1,
  Refresh = 2,
  CheckIn = 3,
}

export enum EnumBroadcastType {
  Announcement = "Announcement",
  Reminder = "Reminder",
}

export enum EnumGender {
  Female = 1,
  Male = 2,
}

export enum EnumAnswer {
  No = 0,
  Yes = 1,
}

export enum EnumCheckInStep {
  Home = 0,
  Scan = 1,
  Email = 2,
  Register = 3,
  Appointment = 4,
  MakeAppointment = 5,
  WalkInNotAllowed = 6,
}

export enum EnumConsent {
  None = -1,
  ConsentForm = 0,
  Profile = 1,
  TermsAndConditions = 2,
}

export enum EnumDaysOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

export enum EnumPeriod {
  Day = 0,
  Week = 7,
  Month = 30,
}

export enum EnumEventTitle {
  Blocked = "Blocked",
  ClinicHours = "Clinic Hours",
  Health360Hours = "Health 360 Hours",
  Health360Virtual = "Health 360 Virtual",
  ProviderAvailability = "Provider Availability",

  // from other tables
  Health360InClinic = "Health 360 In-Clinic",
}
